<template>
  <div class="backimg">
    <div class="search-content" style="width:100%;margin: 0 auto;">
      <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
        <el-menu-item index="300"><strong>待加工</strong><span class="badge" v-if="statusnumber300>0">{{statusnumber300}}</span></el-menu-item>
        <el-menu-item index="alreadymachining">已加工</el-menu-item>
        <el-menu-item index="WorkloadMachine">工作量</el-menu-item>
        <el-menu-item index="all">全部</el-menu-item>
      </el-menu>
      <div class="line"></div>
    </div>
    <el-main>
      <comment :is="currentcomponent" :roletype="'machining'" :mystatus="status" v-if="visible"  @bindTip="bindTip"></comment>
    </el-main>
  </div>

</template>

<script>
  import CstagreementList from './CstagreementList';
  import {countlist} from '@/api/set/csagreement';
  import WorkloadMachine from './WorkloadMachine'

  export default {
    data() {
      return {
        activeIndex: '300',
        currentcomponent: 'CstagreementList',
        visible: true,
        status: '300',
        statuseslist: "300;",
        statusnumber300:0,
      };
    },
    methods: {
      handleSelect(key, keyPath) {
        this.status = key
        this.visible = false
        if (key == "WorkloadMachine") {
          this.currentcomponent = 'WorkloadMachine';
        }else {
          this.currentcomponent = 'CstagreementList'
        }
        this.$nextTick(() => {
          this.visible = true
        })

      },
      bindTip(){
        this.statusnumber300=0
        countlist({statuseslist: this.statuseslist}).then(response => {
          response.data.obj.forEach(item=>{
            if(item.status==300){
              this.statusnumber300=item.number
            }
          })
        })
      }

    },
    mounted() {
      this.bindTip()
    },
    components: {
      CstagreementList,
      WorkloadMachine
    }

  }


</script>
<style scoped>
  .el-main {
    padding: 0px;
    /*height: calc(100vh - 97px);*/
    width:100%;
    margin:0 auto;
    background-color: white;
    overflow: auto;
  }

  .el-menu-item {
    height: 48px !important;
    line-height: 48px !important;
    font-size: 13px;
    padding: 0 18px !important;
  }

  .el-menu.el-menu--horizontal {
    border-bottom: none;
    background: linear-gradient(135deg, #f8f9fc 0%, #eef1f7 100%);
    border-radius: 6px 6px 0 0;
    padding: 0 4px;
  }

  .el-menu--horizontal .el-menu-item:not(.is-disabled):focus,
  .el-menu--horizontal .el-menu-item:not(.is-disabled):hover {
    background: transparent;
    color: #409eff;
  }

  .el-menu--horizontal .el-menu-item.is-active {
    border-bottom: 3px solid #409eff !important;
    color: #222 !important;
    font-weight: 600;
    background: transparent !important;
  }

  .el-menu--horizontal .el-menu-item .badge {
    display: inline-block;
    line-height: 16px;
    font-size: 11px;
    min-width: 16px;
    height: 16px;
    background: linear-gradient(135deg, #f56c6c, #e24545);
    color: #fff;
    text-align: center;
    border-radius: 8px;
    position: relative;
    top: -8px;
    margin-left: 3px;
    padding: 0 4px;
    box-shadow: 0 2px 4px rgba(245,108,108,0.3);
  }
</style>



// WEBPACK FOOTER //
// src/components/testorder/cstagreement/Machining.vue